import './style/AnalyzeDiscussions.scss';
import AnalyzeDiscussions from "./js/AnalyzeDiscussions";

export default AnalyzeDiscussions;
